import React, { useState, useRef, useEffect } from 'react'
import { Box, IconButton, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useFormik } from 'formik'
import GenerativeService from '../../../../../services/generative.service'
import { MuiTextField, MuiButton, Modal, LoaderDotted } from '../../../../../components'
import { IconEdit } from '../../../../../assets/images/icons'
import {
  InputWrap,
  LoginButton,
  Title,
  Wrapper,
  ButtonWrapper,
  SuggestionWrapper,
  SuggestionInputWrapper,
  SuggestionLink,
  LoaderInitiating,
  SuggestionButtonWrap,
} from './style'
import { useGlobalStore } from '../../../../../store'
import { getObjectAsArray } from '../../../../../util'
import { ROLES_MM_PRIMARY } from '../../../../../constants'
import IconMessageEdit from '../../../../../assets/images/icons/icon-message-edit'
import IconBoxEdit from '../../../../../assets/images/icons/icon-box-edit'
import IconBoxAdd from '../../../../../assets/images/icons/icon-box-add'

const Suggestions = ({
  chatData,
  onClose,
  onLoadShow = false,
  showButton = true,
  disabledLinks,
  suggestionClicked,
  parentLoader,
  typing,
  serverStartEvent,
}) => {
  const [anchorElUser, setAnchorElUser] = useState(null)
  const [showSuggestionsModal, setShowSuggestionsModal] = useState(false)
  const { projectIdValue, theme, user } = useGlobalStore()
  // const [loaderList, setLoaderList] = useState(false)
  const [loaderSuggestionList, setLoaderSuggestionList] = useState(false)
  const [suggestionList, setSuggestionList] = useState()
  const [suggestionData, setSuggestionData] = useState()
  const [isServerStarting, setServerStarting] = useState(false)
  const [initiatingMsg, setInitiatingMsg] = useState(0)
  const { id } = useParams()

  const handleOnSuggestions = () => {
    setAnchorElUser(null)
    setShowSuggestionsModal((prev) => !prev)
    onClose && onClose()
    setSuggestionData([])
  }

  const form = useRef()
  const inputRef = useRef()
  const [loader, setLoader] = useState(false)

  const onSubmit = () => {
    setLoader(true)
    const suggestions = suggestionData.filter((f) => f !== '')
    GenerativeService.setSampleAskIAQuestionsForStudyApi({
      studyId: id,
      sampleQuestions: suggestions.join('|'),
    })
      .then((resp) => {
        setSuggestionList(suggestions)
        setSuggestionData(suggestions)
        setLoader(false)
        setShowSuggestionsModal(false)
      })
      .catch((error) => {
        setLoader(false)
        console.log('ERROR : ', error)
      })
  }

  const validation = (values) => {
    const errors = {}
    return errors
  }

  const formik = useFormik({
    validateOnChange: false,
    validateOnBlur: false,
    initialValues: {
      // suggestions: user?.suggestions || '',
      // email: user?.UserEmail || '',
      // phoneNumber: '',
    },
    // validationSchema: Yup.object({
    //   // suggestions: Yup.string().max(25).required('Name is required'),
    //   // email: Yup.string().max(25).required('Email is required'),
    //   // phoneNumber: Yup.number() //.max(25).required('Phone Number is required')
    // }),
    validate: (values) => validation(values),
    onSubmit: (values) => {
      const updatedValues = {}
      onSubmit(updatedValues)
    },
  })

  // const timer = 60000
  const timer = 600

  const initiatingMsgFunc = (counter) => {
    if (counter < timer) {
      const valCnt = counter / 1000
      const valSec = timer / 1000
      const percentage = Math.floor((valCnt / valSec) * 100)

      if (percentage < 31) setInitiatingMsg(`Initializing - Uploading Data ${percentage}%`)
      else if (percentage < 61)
        setInitiatingMsg(`Initializing - Integrating Resources ${percentage}%`)
      else if (percentage <= 100)
        setInitiatingMsg(`Initializing - Kickstarting Q&A Model ${percentage}%`)
      setTimeout(() => {
        initiatingMsgFunc(counter + 1000)
      }, 1000)
    }
  }

  const startServerToGetSuggestionList = () => {
    if (!isNaN(localStorage.getItem('askIaStartServer'))) {
      setServerStarting(true)
      initiatingMsgFunc(0)
      GenerativeService.askQuestionStartServerApi({}, true)
        .then((resp) => {
          setTimeout(() => {
            localStorage.setItem('askIaStartServer', 'done')
            setServerStarting(false)
          }, timer)
          // getSuggestionList()
        })
        .catch((error) => {
          console.log('ERROR : ', error)
        })
    } else {
      setServerStarting(false)
    }
    getSuggestionList()
  }

  useEffect(() => {
    serverStartEvent(isServerStarting)
  }, [isServerStarting])

  const getSuggestionList = () => {
    setLoaderSuggestionList(true)
    GenerativeService.getStudiesApi({ projectId: projectIdValue.ProjectId }, true)
      .then((resp) => {
        if (resp?.[0]?.Study) {
          const data1 = getObjectAsArray(resp[0]?.Study).filter((f) => f.StudyId === id)[0]
          // let data2 = (data1?.SampleQuestions.indexOf('|') !== -1 ) ? data1?.SampleQuestions.split('|') : ['No Suggestions']
          let data2 = data1?.SampleQuestions.split('|').filter((item) => item !== '')
          setSuggestionData([...data2])
          setSuggestionList([...data2])
          setLoaderSuggestionList(false)
        }
      })
      .catch((error) => {
        setLoaderSuggestionList(false)
        const resMessage = error
        console.log('ERROR : ', resMessage)
        // enqueueSnackbar(resMessage, { variant: 'error' })
      })
  }

  const handleChange = (e, i = 0) => {
    const arr = suggestionData
    arr[i] = e.target.value
    setSuggestionData(arr)
  }

  const removeSuggestions = () => {
    const d = suggestionData
    d.pop()
    setSuggestionData([...d])
  }

  const editSuggestionsFunc = () => {
    setShowSuggestionsModal(!disabledLinks)
    getSuggestionList()
  }

  // const isProd = !!window.location.href.match('insightsassistant.mavenmagnet.com')

  useEffect(() => {
    setShowSuggestionsModal(onLoadShow)
  }, [onLoadShow])

  useEffect(() => {
    // isProd ? getSuggestionList() :
    startServerToGetSuggestionList()
  }, [])

  return (
    <>
      {isServerStarting && (
        <LoaderInitiating>
          <LoaderDotted msg={initiatingMsg} />
        </LoaderInitiating>
      )}
      {!!suggestionList?.length && (
        <SuggestionWrapper>
          {suggestionList?.map((d, index) => {
            return (
              <SuggestionLink
                variant='primary'
                disabled={isServerStarting || disabledLinks}
                key={index}
                onClick={() => suggestionClicked(d)}
              >
                <IconMessageEdit />
                <Typography
                  sx={{
                    color: (theme) => theme.palette.text.secondary,
                  }}
                  fontSize={'16px'}
                  fontWeight={400}
                >
                  {d}
                </Typography>
              </SuggestionLink>
            )
          })}
        </SuggestionWrapper>
      )}

      {showButton && ROLES_MM_PRIMARY.includes(user.UserType) && (
        <SuggestionButtonWrap
          onClick={() => editSuggestionsFunc()}
          disabled={isServerStarting || disabledLinks}
        >
          <IconButton aria-label='Edit'>
            {suggestionList?.length ? (
              <IconBoxEdit fill={theme === 'light' ? '#095BBD' : '#CEDEF2'} />
            ) : (
              <IconBoxAdd fill={theme === 'light' ? '#095BBD' : '#CEDEF2'} />
            )}
          </IconButton>
          <Typography className='suggestions-text'>
            {suggestionList?.length ? 'Edit Suggestions' : 'Add Suggestions'}
          </Typography>
        </SuggestionButtonWrap>
      )}
      {showSuggestionsModal && (
        <Modal
          title='Add Suggestions'
          showClose={true}
          onClose={handleOnSuggestions}
          styleType='themeV2'
        >
          <Wrapper>
            <form ref={form} onSubmit={formik.handleSubmit}>
              {/* <Title variant='body1'>Add Suggestions</Title> */}
              <SuggestionInputWrapper>
                {suggestionData?.map((data, i) => {
                  const name = 'suggestions__' + data.trim() + '_' + i
                  return (
                    <InputWrap key={i}>
                      <MuiTextField
                        fullWidth
                        ref={inputRef[i]}
                        title={`Suggestion ${i + 1}`}
                        name={name}
                        onChange={(e) => handleChange(e, i)}
                        type='text'
                        defaultValue={data}
                        variant='outlined'
                      />
                    </InputWrap>
                  )
                })}
              </SuggestionInputWrapper>

              <ButtonWrapper>
                {suggestionData.length > 1 && (
                  <MuiButton
                    color='primary'
                    variant='text'
                    type='button'
                    onClick={() => removeSuggestions()}
                  >
                    {' '}
                    - Remove
                  </MuiButton>
                )}
                <MuiButton
                  color='primary'
                  variant='text'
                  type='button'
                  onClick={() => setSuggestionData([...suggestionData, ''])}
                >
                  {' '}
                  + Add More
                </MuiButton>
              </ButtonWrapper>

              <LoginButton
                variant='outlined'
                type='submit'
                className='login-button'
                onClick={formik.handleSubmit}
                disabled={loader || false}
              >
                Submit
              </LoginButton>
            </form>
          </Wrapper>
        </Modal>
      )}
    </>
  )
}

export default Suggestions
